/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMessageDollar = createReactComponent("message-dollar", "IconMessageDollar", [
  ["path", { d: "M8 9h8", key: "svg-0" }],
  ["path", { d: "M8 13h6", key: "svg-1" }],
  [
    "path",
    {
      d: "M13 18l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v3.5",
      key: "svg-2"
    }
  ],
  [
    "path",
    {
      d: "M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5",
      key: "svg-3"
    }
  ],
  ["path", { d: "M19 21v1m0 -8v1", key: "svg-4" }]
]);

export { IconMessageDollar as default };
//# sourceMappingURL=IconMessageDollar.js.map
